<div class="row">
  <div class="col-lg-3">
    <label>Timeframe:</label>
    <select class="form-control" [(ngModel)]="dateRange" (ngModelChange)="checkDateRanges()">
      <option value="0">Today</option>
      <option value="7">Last 7 Days</option>
      <option value="30">Last 30 Days</option>
      <option value="custom">Custom Date Range</option>
    </select>
  </div>
</div>
<div *ngIf="dateRange == 'custom'" class="row" [formGroup]="form">
  <div class="col-lg-4">
    <label>Dates</label>
    <lib-date-range-picker formControlName="dateRange"></lib-date-range-picker>
  </div>
</div>
<br />
<button
  [disabled]="dateError"
  cpGTagEvent
  [params]="{ event_label: 'client_reports_generate' }"
  class="btn btn-primary"
  (click)="generate()">
  Generate
</button>
@if (show) {
  <hr />
  <div class="card">
    <div class="card-body" *ngIf="reportView == 'people-changes'">
      <people-changes-report
        [clientCode]="clientCode"
        [startDate]="form.get('dateRange').value?.start"
        [endDate]="form.get('dateRange').value?.end">
      </people-changes-report>
    </div>
    <div class="card-body" *ngIf="reportView == 'payroll-audit'">
      <payroll-audit-log
        [clientCode]="clientCode"
        [startDate]="form.get('dateRange').value?.start"
        [endDate]="form.get('dateRange').value?.end">
      </payroll-audit-log>
    </div>
  </div>
}
